import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  Table,
  ButtonGroup,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Input,
  Label
} from "reactstrap";
import Select from "react-select";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper, uiHelper, constant } from "../helpers";
import { TextFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import SelectFilter from "./SelectFilter";

const getParts = () => api.fetch('Reference/Parts').then(response => {
  return {
    partList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));

const getTestTypes = () => api.fetch('Reference/COATestTypes').then(response => {
  return {
    testList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));

export default class COAIngredient extends Component {
  static displayName = COAIngredient.name;
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      pagedList: null,
      sortColumn: "Name",
      sortAscending: true,
      productList: [],
      partList:[],
      testList:[],
      dropdownOpen: false,
      prestineIngredient: null,
    };

    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);

  }

  componentDidMount() {
    Promise.all([getParts(), getTestTypes()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
        this.setState(newStatus, () => this.refreshList());
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/COAIngredients", payload)
      .then(response => {
        if (response.data) {
          let list = _.map(response.data.dataSource, l => {
            l.editing = false;
            l.part = uiHelper.resolveValue(null, l.partId, l.partName);
            return l;
          });
          
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: list,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters },
      () => { this.refreshList(null, null, filters, 1) }
    );
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }
  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen })
  }

  onInputChange(event, id, fieldName) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index][fieldName] = event.target ? event.target.value : event;

    this.setState({
      pagedList: {...this.state.pagedList, list: list}
    })
  }

  onCheckBoxChange(id, fieldName) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index][fieldName] = !list[index][fieldName];
    this.setState({
      pagedList: { ...this.state.pagedList, list: list }
    });
  }

  onEdit(id) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    let prestine = Object.assign({}, list[index]);
    list[index].editing = true;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      prestineIngredient: prestine
    })
  }
  onCancelEdit(id) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index] = Object.assign({}, this.state.prestineIngredient);
    list[index].editing = false;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      prestineIngredient: null
    })
  }
  onSave(id) {
    let list = this.state.pagedList.list.slice();
      const item = _.find(list, l => l.id === id);
      //console.log(item, "item")
    if (!item.beginningRange && item.endingRange){ Alert.error("please provide a beginning range."); return;}
    if (!item.endingRange && item.beginningRange){ Alert.error("Please provide a ending range"); return;}
    if( item.beginningRange && item.endingRange  
        && Number(item.beginningRange) > Number(item.endingRange)) {Alert.error("Please make sure the beginning range is less then or equal to the ending range.");
        return;}
      let payload = {
        Id: item.id,
        Name: item.name,
        Unit: item.unit,
        BeginningRange: item.beginningRange ? Number(item.beginningRange) : null,
        EndingRange: item.endingRange ? Number(item.endingRange) : null,
        PartId: item.part ? item.part.value : null,
        IncludeInCOAReport: item.includeInCOAReport
      }
      api.post("admin/SaveCOAIngredient", payload)
        .then(r => {
          if (r && r.data && r.data.success) {
            this.refreshList();
            Alert.success("Ingredient details was saved.")
          } else {
            Alert.error(r.data.message || "An error occurred. Ingredient cannot be saved at this time.")
          }
        }).catch(error => {
          Alert.error("Something went wrong. Ingredient details cannot be saved at this time.")
        });
    
  }
  render() {
    return (
      <div className="ml-4 mr-4">
        <Row className={"p-2"}>
          <Col>
            <h4>COA Ingredients</h4>
          </Col>
        </Row>

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor pl-1 pr-1">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              {/*<Col xs="3">*/}
              {/*  <SelectFilter*/}
              {/*      filterName ="partId"*/}
              {/*      displayName="CBDMD Ingredient"*/}
              {/*      onChangeCallback={this.onChangeFilter}*/}
              {/*      isSingleSelect={true}*/}
              {/*      options={this.state.partList}*/}
              {/*      values={filterHelper.get_value("partId")}*/}
              {/*      />*/}
              {/*</Col>*/}
              <Col xs="3">
                <SelectFilter
                  filterName="includeInCOAReport"
                  displayName="Included in Report Only"
                  onChangeCallback={this.onChangeFilter}
                  isSingleSelect={true}
                  options={constant.activeList}
                  values={filterHelper.get_value("includeInCOAReport")}
                />
              </Col>
              <Col>
              <SelectFilter
                  filterName="testType"
                  displayName="TestType"
                  onChangeCallback={this.onChangeFilter}
                  //isMulti={true}
                  isSingleSelect={true}
                  options={this.state.testList}
                  values={filterHelper.get_value("testType")}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  {/*<th>Units</th>*/}
                  <th>Range</th>
                  {/*<th>CBDMD Ingredient</th>*/}
                  <th>Include In Report</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(e => (
                    <tr key={e.id}>
                      {e.editing ? (
                        <Fragment>
                          <td>{e.name}</td>
                          {/*<td>{e.units}</td>*/}
                          <td>
                            <div>
                              <Row>
                                <Col>
                                  <Input type="number" step="0.01" 
                                    value={e.beginningRange} 
                                    onChange={(evt) => this.onInputChange(evt, e.id, "beginningRange")} 
                                  />
                                </Col>
                                
                                <Col>
                                  <Input type="number" step="0.01" 
                                    value={e.endingRange} 
                                    onChange={(evt) => this.onInputChange(evt, e.id, "endingRange")} 
                                  />
                                </Col>
                              </Row>
                            </div>
                          </td>
                          {/*<td>*/}
                          {/*  <Select */}
                          {/*    options={this.state.partList}*/}
                          {/*    value={e.part}*/}
                          {/*    onChange={(evt) => this.onInputChange(evt, e.id, "part")}*/}
                          {/*  />*/}
                          {/*</td>*/}
                          <td>
                            <Label for="includeInCOAReport">
                              <input
                                type="checkbox"
                                className="mr-2"
                                id="includeInCOAReport"
                                name="includeInCOAReport"
                                checked={e.includeInCOAReport}
                                value={e.includeInCOAReport}
                                onClick={() => this.onCheckBoxChange(e.id, "includeInCOAReport")}
                              />
                            Include In COA Report?
                          </Label>

                          </td>

                          <td>
                            <ButtonGroup>
                              <Button className={"cbdmdSecondary buttonGroupSpacing"} size="sm" title={"Cancel Edit"} onClick={() => this.onCancelEdit(e.id)}>
                                <FontAwesomeIcon icon="reply" />
                              </Button>
                              <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Save Details"} onClick={() => this.onSave(e.id)}>
                                <FontAwesomeIcon icon="save" />
                              </Button>
                            </ButtonGroup>
                          </td>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <td>{e.name}</td>
                          {/*<td>{e.units}</td>*/}
                          <td>
                            <span>
                              {e.beginningRange} - {e.endingRange}
                            </span>
                          </td>
                          {/*<td>{e.part && e.part.label}</td>*/}
                          <td>
                            <FontAwesomeIcon className={e.includeInCOAReport ? "successText" : "cbdmdDangerText"} icon={e.includeInCOAReport ? "check-circle" : "times"} />
                          </td>
                          <td>
                            <ButtonGroup>
                                <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Edit Details"} onClick={() => this.onEdit(e.id)}>
                                <FontAwesomeIcon icon="edit" />
                              </Button>
                            </ButtonGroup>
                          </td>
                        </Fragment>
                      )}
                    </tr>
                  ))) : (<tr>
                      <td>
                          No Records available
                      </td>
                  </tr>)}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/COAIngredient.js